let env

if (typeof window !== 'undefined' && window.__APP_STATE__) {
  env = {
    ...window.__APP_STATE__.env,
  }
} else {
  env = {
    APP_VERSION: process.env.APP_VERSION,
    HOST: process.env.HOST,
    APP_ENV: process.env.APP_ENV,
    API_URL: process.env.API_URL,
    GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
    STRIPE_PUBLIC_KEY: process.env.STRIPE_PUBLIC_KEY,
    IMAGE_URL: process.env.IMAGE_URL,
    RH_URL: process.env.RH_URL,
    CATERING_URL: process.env.CATERING_URL,
    SENTRY_DSN: process.env.SENTRY_DSN,
    GA_TRACKING_ID: process.env.GA_TRACKING_ID,
    GA_GTM_ID: process.env.GA_GTM_ID,
    HEALTH_CODE_FINDER_URL: process.env.HEALTH_CODE_FINDER_URL,
    POSTHOG_TOKEN: process.env.POSTHOG_TOKEN,
    POSTHOG_HOST: process.env.POSTHOG_HOST,
    HEADER_BANNER_ENABLED: process.env.HEADER_BANNER_ENABLED,
    HEADER_BANNER_CONTENT: process.env.HEADER_BANNER_CONTENT,
    HEADER_BANNER_LINK_URL: process.env.HEADER_BANNER_LINK_URL,
    HEADER_BANNER_LINK_TEXT: process.env.HEADER_BANNER_LINK_TEXT,
    SITE_NAME: process.env.SITE_NAME || 'Mobile Food Alliance',
    INTERNAL_BLOG_URL: process.env.INTERNAL_BLOG_URL,
    INTERNAL_HOST: process.env.INTERNAL_HOST
  }
}

export default env
